import { Modal, Step, StepLabel, Stepper, TextField } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../AuthContext/AuthContext";
import { loader } from "../../Func_genericas/loader";
import { cores, mensagem_tem_a_certeza_de_apagar_alteracoes, operacao_erro, operacao_sucesso } from "../../Func_genericas/valores_estaticos";
import { CustomTextField } from "../../Styles/theme/customThemeprovider";
import { post, put } from "../../Services/tokenConfig";
import { func_print } from "../../Func_genericas/func_print";
import ConfirmDialog from "../../Components/CustomDialog/customdialog";
import { IOperacaoAgricola } from "../../Interfaces/atividade/atividade";
import { IPlanoERPSchema } from "../../Interfaces/financeiro/financeiro";
import Switch from "react-switch";

interface I_aux {
    lista: IOperacaoAgricola[],
    flag_open_modal: boolean,
    set_flag_open_modal: React.Dispatch<React.SetStateAction<boolean>>,
    flag_open_modal_ver_mais: boolean,
    set_flag_open_modal_ver_mais: React.Dispatch<React.SetStateAction<boolean>>,
    flag_open_modal_edit: boolean,
    set_flag_open_modal_edit: React.Dispatch<React.SetStateAction<boolean>>,
    flag_open_modal_add: boolean,
    set_flag_open_modal_add: React.Dispatch<React.SetStateAction<boolean>>,
    setMessage: React.Dispatch<React.SetStateAction<string>>,
    setOpenSnackSuccess: React.Dispatch<React.SetStateAction<boolean>>,
    setOpenSnackError: React.Dispatch<React.SetStateAction<boolean>>,
    set_lista: React.Dispatch<React.SetStateAction<IOperacaoAgricola[]>>,
    set_obj_new: React.Dispatch<React.SetStateAction<IOperacaoAgricola | undefined>>,
    obj_new: IOperacaoAgricola | undefined,
    lista_financeiro: IPlanoERPSchema[],

}

export const Modaladdatividade: React.FC<I_aux> = ({
    lista,
    flag_open_modal,
    set_flag_open_modal,
    flag_open_modal_ver_mais,
    set_flag_open_modal_ver_mais,
    flag_open_modal_edit,
    set_flag_open_modal_edit,
    flag_open_modal_add,
    set_flag_open_modal_add,
    setMessage,
    setOpenSnackSuccess,
    setOpenSnackError,
    set_lista,
    set_obj_new,
    obj_new,
    lista_financeiro
}) => {
    const auth = useContext(AuthContext);

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [passo_atual, set_passo_atual] = useState<number>(0);

    const steps = [
        'Selecionar Plano ERP',
        'Configurar Campos do Registo da Atividade',
    ];

    const [hover, setHover] = useState({ flag: false, id_plano: 0 });

    const [error_custo_estimado, set_error_custo_estimado] = useState<boolean>(false);
    const [error_custo_real, set_error_custo_real] = useState<boolean>(false);

    const [flag_editado, set_flag_editado] = useState<boolean>(false);
    const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes] = useState<boolean>(false);

    const [obj_finaceiro_selecionado, set_obj_finaceiro_selecionado] = useState<IPlanoERPSchema | undefined>(undefined);


    useEffect(() => {
        (async () => {
            lista_financeiro.find((el) => {
                if (el.id_plano === obj_new?.id_plano) {
                    set_obj_finaceiro_selecionado(el);
                }
            })

        })();
    }, []);


    const handler_add = async () => {
        try {
            setIsLoading(true);
            let res = await post(auth.token.cookie_token, 'api/operacoes/new', {
                payload: {
                    id_plano: obj_finaceiro_selecionado?.id_plano === undefined ? 0 : obj_finaceiro_selecionado?.id_plano,
                    fase_producao: obj_new?.fase_producao === undefined ? '' : obj_new?.fase_producao,
                    tipo_operacao: obj_new?.tipo_operacao === undefined ? '' : obj_new?.tipo_operacao,
                    descricao: obj_new?.descricao === undefined ? '' : obj_new?.descricao,
                    data_inicio: obj_new?.data_inicio === undefined ? null : obj_new?.data_inicio,
                    data_fim: obj_new?.data_fim === undefined ? null : obj_new?.data_fim,
                    estado: obj_new?.estado === undefined ? '' : obj_new?.estado,
                    prioridade: obj_new?.prioridade === undefined ? '' : obj_new?.prioridade,
                    custo_estimado: obj_new?.custo_estimado === undefined ? 0 : obj_new?.custo_estimado?.toString().replace(',', '.'),
                    custo_real: obj_new?.custo_real === undefined ? 0 : obj_new?.custo_real?.toString().replace(',', '.'),
                    recorrente: obj_new?.recorrente === undefined ? false : obj_new?.recorrente,
                    frequencia: obj_new?.frequencia === undefined ? '' : obj_new?.frequencia,
                    id_operacao_anterior: obj_new?.id_operacao_anterior === undefined ? null : obj_new?.id_operacao_anterior,
                    condicoes_meteo: obj_new?.condicoes_meteo === undefined ? '' : obj_new?.condicoes_meteo,
                    notas: obj_new?.notas === undefined ? '' : obj_new?.notas,
                }
            });
            if (lista.length === 0) {
                set_lista([res.data.result])

            } else {
                set_lista((old: any) => [...old, res.data.result])

            }
            setMessage(operacao_sucesso)
            setOpenSnackSuccess(true);
            setIsLoading(false);
            func_reset_all()

        } catch (error) {
            func_print("handler_add", error, true);
            setMessage(operacao_erro)
            setOpenSnackError(true);
            setIsLoading(false);
        }
    }
    const handler_edit = async () => {

        try {
            setIsLoading(true);
            let res = await put(auth.token.cookie_token, 'api/operacoes/' + obj_new?.id_operacao, {
                payload: {
                    id_operacao: obj_new?.id_operacao === undefined ? 0 : obj_new?.id_operacao,
                    id_plano: obj_finaceiro_selecionado?.id_plano === undefined ? 0 : obj_finaceiro_selecionado?.id_plano,
                    fase_producao: obj_new?.fase_producao === undefined ? '' : obj_new?.fase_producao,
                    tipo_operacao: obj_new?.tipo_operacao === undefined ? '' : obj_new?.tipo_operacao,
                    descricao: obj_new?.descricao === undefined ? '' : obj_new?.descricao,
                    data_inicio: obj_new?.data_inicio === undefined ? null : obj_new?.data_inicio,
                    data_fim: obj_new?.data_fim === undefined ? null : obj_new?.data_fim,
                    estado: obj_new?.estado === undefined ? '' : obj_new?.estado,
                    prioridade: obj_new?.prioridade === undefined ? '' : obj_new?.prioridade,
                    custo_estimado: obj_new?.custo_estimado === undefined ? 0 : obj_new?.custo_estimado?.toString().replace(',', '.'),
                    custo_real: obj_new?.custo_real === undefined ? 0 : obj_new?.custo_real?.toString().replace(',', '.'),
                    recorrente: obj_new?.recorrente === undefined ? false : obj_new?.recorrente,
                    frequencia: obj_new?.frequencia === undefined ? '' : obj_new?.frequencia,
                    id_operacao_anterior: obj_new?.id_operacao_anterior === undefined ? null : obj_new?.id_operacao_anterior,
                    condicoes_meteo: obj_new?.condicoes_meteo === undefined ? '' : obj_new?.condicoes_meteo,
                    notas: obj_new?.notas === undefined ? '' : obj_new?.notas,

                }
            });

            let aux_list = lista.map((el) => {
                if (el.id_operacao === obj_new?.id_operacao) {
                    return res.data.result
                } else {
                    return el
                }
            })

            set_lista(aux_list)


            setMessage(operacao_sucesso)
            setOpenSnackSuccess(true);
            setIsLoading(false);
            func_reset_all()

        } catch (error) {
            func_print("handler_edit", error, true);
            setMessage(operacao_erro)
            setOpenSnackError(true);
            setIsLoading(false);
        }


    }

    const onInputChange = (e: any) => {
        const { name, value } = e.target;
        set_flag_editado(true)

        if (name === 'custo_estimado') {
            if (!/^(\d+([.,]\d+)?)$/.test(value)) {
                set_error_custo_estimado(true)
            } else {
                set_error_custo_estimado(false)
            }
            set_obj_new((prev: any) => ({
                ...prev,
                [name]: value,
            }));
        } else if (name === 'custo_real') {
            if (!/^(\d+([.,]\d+)?)$/.test(value)) {
                set_error_custo_real(true)
            } else {
                set_error_custo_real(false)
            }
            set_obj_new((prev: any) => ({
                ...prev,
                [name]: value,
            }));
        } else {
            set_obj_new((prev: any) => ({
                ...prev,
                [name]: value,
            }));
        }
    }


    const func_reset_all = () => {
        set_obj_new(undefined);
        set_flag_open_modal_edit(false);
        set_flag_open_modal(false);
        set_flag_open_modal(false);
        set_flag_editado(false)
        set_flag_open_modal_ver_mais(false);
        set_flag_open_modal_add(false);
        set_error_custo_real(false);
        set_error_custo_estimado(false);

    }
    const handleCloseDialog = () => {
        func_reset_all()
        set_flag_editado(false)
        set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)
    };

    return (<Modal
        style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}
        open={flag_open_modal}
    >
        <div className="flex flex-col bg-white w-[70%] max-h-[80%] rounded-xl overflow-hidden">
            <div className="flex items-center justify-between w-full p-4 border-b border-gray-100">
                <h2 className="text-xl font-semibold text-gray-800 m-0 pl-2">
                    {
                        flag_open_modal_edit === true ? 'Editar Atividade' :
                            flag_open_modal_ver_mais === true ? 'Detalhes do Atividade' :
                                'Adicionar Atividade'
                    }

                </h2>
                <button
                    type="button"
                    onClick={() => {
                        if (flag_editado) {
                            set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                        } else {
                            set_flag_open_modal(false)
                            set_flag_open_modal_edit(false)
                            set_flag_open_modal_ver_mais(false)
                        }
                    }}
                    className="p-1 text-gray-400 hover:text-gray-600 transition-colors border-0 outline-none cursor-pointer !bg-transparent hover:!bg-transparent"
                >
                    <CloseIcon sx={{ fontSize: 24 }} />
                </button>
            </div>

            {
                isLoading === true ?
                    loader() :
                    <>
                        <div className="flex flex-col items-center w-full flex-1 overflow-auto">
                            <div className="flex flex-col items-center w-full flex-1 overflow-auto">
                                <div className="flex items-center w-full py-4 px-4">
                                    <Stepper activeStep={passo_atual} alternativeLabel className="w-full">
                                        {steps.map((label) => (
                                            <Step key={label} sx={{
                                                '& .MuiStepLabel-root .Mui-completed': {
                                                    color: cores.cor3, // circle color (COMPLETED)
                                                },
                                                '& .MuiStepLabel-label.Mui-completed.MuiStepLabel-alternativeLabel':
                                                {
                                                    color: cores.cor2, // Just text label (COMPLETED)
                                                },
                                                '& .MuiStepLabel-root .Mui-active': {
                                                    color: cores.cor1, // circle color (ACTIVE)
                                                },
                                                '& .MuiStepLabel-label.Mui-active.MuiStepLabel-alternativeLabel':
                                                {
                                                    color: cores.cor1, // Just text label (ACTIVE)
                                                },
                                                '& .MuiStepLabel-root .Mui-active .MuiStepIcon-text': {
                                                    fill: 'white', // circle's number (ACTIVE)
                                                },
                                            }}>
                                                <StepLabel>{label}</StepLabel>
                                            </Step>
                                        ))}
                                    </Stepper>

                                </div>

                                {
                                    passo_atual === 0 ?
                                        <div className="flex flex-col w-full p-6">


                                            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4 w-full">
                                                {
                                                    lista_financeiro.length === 0 ? (
                                                        <div className="text-gray-400 py-4">Cadernos Não Encontrados</div>
                                                    ) : (
                                                        lista_financeiro.map((el, key) => {
                                                            const isSelected = obj_finaceiro_selecionado?.id_plano === el.id_plano;
                                                            const isHovered = hover.flag && hover.id_plano === el.id_plano;
                                                            return (
                                                                <div
                                                                    key={key}
                                                                    className={`
                              flex flex-col items-center justify-center min-w-0 p-4 rounded-xl cursor-pointer
                              transition-all duration-200
                              ${isSelected ? 'ring-2 ring-[#c94f1e] bg-[#f2d1c2]/30' : 'bg-gray-50/80'}
                              ${isHovered ? 'shadow-md' : 'shadow-sm'}
                            `}
                                                                    onMouseEnter={() => setHover({ flag: true, id_plano: el.id_plano ?? 0 })}
                                                                    onMouseLeave={() => setHover({ flag: false, id_plano: el.id_plano ?? 0 })}
                                                                    onClick={() => {
                                                                        if (obj_finaceiro_selecionado?.id_plano === el.id_plano) {
                                                                            set_obj_finaceiro_selecionado(undefined);

                                                                        } else {

                                                                            set_obj_finaceiro_selecionado(el);
                                                                        }

                                                                    }}
                                                                >
                                                                    <div className="text-sm font-medium text-gray-800 text-center">
                                                                        {el.nome}
                                                                    </div>
                                                                    <div
                                                                        className={`mt-2 w-full h-1 rounded-full ${isSelected ? 'bg-[#c94f1e]' : 'bg-gray-200'}`}
                                                                    />
                                                                </div>
                                                            );
                                                        })
                                                    )
                                                }
                                            </div>

                                            <div className="flex justify-end w-full pt-4">

                                                <button
                                                    type="button"
                                                    onClick={() => {

                                                        if (obj_finaceiro_selecionado?.id_plano === undefined) {
                                                            setMessage("Selecione um caderno para avançar")
                                                            setOpenSnackError(true);
                                                        } else {
                                                            set_passo_atual(1);

                                                        }

                                                    }}
                                                    className="px-5 py-2.5 rounded-xl font-medium text-sm text-white bg-[#c94f1e] hover:bg-[#b84720] transition-colors border-0 outline-none cursor-pointer"
                                                >
                                                    Seguinte
                                                </button>
                                            </div>
                                        </div> :
                                        passo_atual === 1 ?

                                            <div className="flex flex-col w-full p-6 ">
                                                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 w-full items-start">
                                                    <div className="w-full">
                                                        <CustomTextField
                                                            variant="outlined"
                                                            label='Fase de Produção'
                                                            name="fase_producao"
                                                            value={obj_new?.fase_producao === undefined ? '' : obj_new?.fase_producao}
                                                            onChange={onInputChange}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                    </div>
                                                    <div className="w-full">
                                                        <CustomTextField
                                                            variant="outlined"
                                                            label='Tipo de Operação'
                                                            name="tipo_operacao"
                                                            value={obj_new?.tipo_operacao === undefined ? '' : obj_new?.tipo_operacao}
                                                            onChange={onInputChange}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                    </div>
                                                    <div className="w-full">
                                                        <CustomTextField
                                                            variant="outlined"
                                                            label='Estado'
                                                            name="estado"
                                                            value={obj_new?.estado === undefined ? '' : obj_new?.estado}
                                                            onChange={onInputChange}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 w-full items-start">
                                                    <div className="w-full">
                                                        <CustomTextField
                                                            variant="outlined"
                                                            label='Custo Estimado'
                                                            name="custo_estimado"
                                                            error={error_custo_estimado}
                                                            helperText={error_custo_estimado ? 'Insira um valor numérico' : ""}
                                                            value={obj_new?.custo_estimado === undefined ? '' : obj_new?.custo_estimado}
                                                            onChange={onInputChange}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                    </div>
                                                    <div className="w-full">
                                                        <CustomTextField
                                                            variant="outlined"
                                                            label='Custo Real'
                                                            name="custo_real"
                                                            error={error_custo_real}
                                                            helperText={error_custo_real ? 'Insira um valor numérico' : ""}
                                                            value={obj_new?.custo_real === undefined ? '' : obj_new?.custo_real}
                                                            onChange={onInputChange}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                    </div>
                                                    <div className="w-full">
                                                        <CustomTextField
                                                            variant="outlined"
                                                            label='Frequência'
                                                            name="frequencia"
                                                            value={obj_new?.frequencia === undefined ? '' : obj_new?.frequencia}
                                                            onChange={onInputChange}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 w-full items-start">
                                                    <div className="w-full">
                                                        <TextField
                                                            variant="outlined"
                                                            label='Data Início'
                                                            name="data_inicio"
                                                            type="date"
                                                            value={obj_new?.data_inicio === undefined ? '' : obj_new?.data_inicio}
                                                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                                set_flag_editado(true)

                                                                set_obj_new((old: any) => ({
                                                                    ...old,
                                                                    ['data_inicio']: event.target.value,
                                                                }));

                                                            }}
                                                            fullWidth
                                                            margin="normal"
                                                            InputLabelProps={{ shrink: true }}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                    </div>
                                                    <div className="w-full">
                                                        <TextField
                                                            variant="outlined"
                                                            label='Data Fim'
                                                            name="data_fim"
                                                            type="date"
                                                            value={obj_new?.data_fim === undefined ? '' : obj_new?.data_fim}
                                                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                                set_flag_editado(true)

                                                                set_obj_new((old: any) => ({
                                                                    ...old,
                                                                    ['data_fim']: event.target.value,
                                                                }));

                                                            }}
                                                            fullWidth
                                                            margin="normal"
                                                            InputLabelProps={{ shrink: true }}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                    </div>
                                                    <div className="w-full">
                                                        <CustomTextField
                                                            variant="outlined"
                                                            label='Notas'
                                                            name="notas"
                                                            value={obj_new?.notas === undefined ? '' : obj_new?.notas}
                                                            onChange={onInputChange}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 w-full items-start">
                                                    <div className="w-full">
                                                        <CustomTextField
                                                            variant="outlined"
                                                            label='Descrição'
                                                            name="descricao"
                                                            value={obj_new?.descricao === undefined ? '' : obj_new?.descricao}
                                                            onChange={onInputChange}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                    </div>
                                                    <div className="w-full">
                                                        <CustomTextField
                                                            variant="outlined"
                                                            label='Prioridade'
                                                            name="prioridade"
                                                            value={obj_new?.prioridade === undefined ? '' : obj_new?.prioridade}
                                                            onChange={onInputChange}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                    </div>
                                                    <div className="w-full">


                                                        <div className="mt-5 text-xs font-semibold uppercase tracking-wider text-gray-400">Recorrente</div>

                                                        <Switch
                                                            height={22}
                                                            width={44}
                                                            onColor={cores.cor1}
                                                            offColor="#e5e7eb"
                                                            onChange={() => {

                                                                set_flag_editado(true)

                                                                set_obj_new((old: any) => ({
                                                                    ...old,
                                                                    ['recorrente']: !obj_new?.recorrente,
                                                                }));
                                                            }}
                                                            checked={obj_new?.recorrente ?? false}
                                                        // disabled={flag_open_modal_ver_mais === true ? true : false}

                                                        />
                                                    </div>
                                                </div>

                                                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 w-full items-start">
                                                    <div className="w-full">
                                                        <CustomTextField
                                                            variant="outlined"
                                                            label='Condições Meteo'
                                                            name="condicoes_meteo"
                                                            value={obj_new?.condicoes_meteo === undefined ? '' : obj_new?.condicoes_meteo}
                                                            onChange={onInputChange}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                    </div>
                                                    {/* <div className="w-full">
                                                        <CustomTextField
                                                            variant="outlined"
                                                            label='Notas'
                                                            name="notas"
                                                            value={obj_new?.notas === undefined ? '' : obj_new?.notas}
                                                            onChange={onInputChange}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />


                                                    </div> */}
                                                </div>

                                                <div className="flex justify-between w-full pt-4">
                                                    <button
                                                        type="button"
                                                        onClick={() => set_passo_atual(0)}
                                                        className="px-5 py-2.5 rounded-xl font-medium text-sm text-gray-600 bg-gray-100 hover:bg-gray-200 transition-colors border-0 outline-none cursor-pointer"
                                                    >
                                                        Voltar
                                                    </button>
                                                    <button
                                                        type="button"
                                                        onClick={() => {

                                                            if (error_custo_real === true) {
                                                                set_error_custo_real(true);

                                                            } else if (error_custo_estimado === true) {
                                                                set_error_custo_estimado(true);
                                                            } else {
                                                                set_error_custo_real(false);
                                                                set_error_custo_estimado(false);

                                                                if (flag_open_modal_edit === true && flag_open_modal_add === false) {
                                                                    handler_edit();
                                                                } else if (flag_open_modal_add === true) {
                                                                    handler_add();
                                                                }
                                                            }
                                                        }}
                                                        className="px-5 py-2.5 mt-4 rounded-xl font-medium text-sm text-white bg-[#c94f1e] hover:bg-[#b84720] transition-colors border-0 outline-none cursor-pointer"
                                                    >
                                                        {
                                                            flag_open_modal_edit === true ? 'Guardar Alterações' : 'Adicionar Atividade'
                                                        }
                                                    </button>
                                                </div>
                                            </div>

                                            :
                                            null
                                }



                            </div>



                        </div>
                    </>
            }
            <ConfirmDialog
                open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes}
                onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)}
                onConfirm={() => handleCloseDialog()}
                message={mensagem_tem_a_certeza_de_apagar_alteracoes}
            />
        </div>



    </Modal>)

}
